var map = {
	"./arrows/angle-small-right.svg": 2480,
	"./arrows/arrow-thick-down.svg": 2481,
	"./arrows/arrow-thick-up.svg": 2482,
	"./core/alert-triangle-fill.svg": 2483,
	"./core/check-circle-fill.svg": 2484,
	"./core/check-medium.svg": 2485,
	"./core/check-thick.svg": 2486,
	"./core/close-medium.svg": 2487,
	"./core/cloud-download-fill.svg": 2488,
	"./core/cloud-upload-fill.svg": 2489,
	"./core/cloud-upload-line.svg": 2490,
	"./core/exclamation-circle-fill.svg": 2491,
	"./core/exclamation-circle-line.svg": 2492,
	"./core/lock-normal.svg": 2493,
	"./core/plus-small.svg": 2494,
	"./core/question-circle-fill.svg": 2495,
	"./core/sync-alt-fill.svg": 2496,
	"./label/bambee-certified.svg": 2497,
	"./menu/ellipsis-v.svg": 2498,
	"./reportCards/check-circle.svg": 2499,
	"./reportCards/minus-circle.svg": 2500,
	"./reportCards/need_improvement.svg": 2501,
	"./reportCards/outstanding.svg": 2502,
	"./reportCards/satisfactory.svg": 2503,
	"./reportCards/skipped-circle.svg": 2504,
	"./reportCards/skipped.svg": 2505,
	"./reportCards/star-circle.svg": 2506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2479;